import { useState } from "react";

const now = new Date();
const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
const eventEnd = new Date("2025-12-14");
const beaconEnd = new Date("2025-12-01");
const shardEnd = new Date("2025-12-14");
const maxRemainingDays = Math.max(Math.floor((eventEnd - today) / (1000 * 60 * 60 * 24)) + 1, 0);

export default function BetaTokenCalculator() {
  const [tokensSoFar, setTokensSoFar] = useState(0);
  const [expectedBeacons, setExpectedBeacons] = useState(0);
  const [beaconTier, setBeaconTier] = useState("CAT-I");
  const [shardCount, setShardCount] = useState(0);

  const beaconTokenValues = {
    "CAT-I": 3,
    "CAT-II": 7,
    "CAT-III": 12,
    "CAT-IV": 18,
    "CAT-V": 25,
    "CAT-VI": 33
  };

  const isBeaconOngoing = today <= beaconEnd;
  const isShardOngoing = today <= shardEnd;
  const remainingBountyTokens = maxRemainingDays * 60;

  const expectedBeaconTokens = isBeaconOngoing ? expectedBeacons * beaconTokenValues[beaconTier] : 0;
  const expectedShardTokens = isShardOngoing ? shardCount * 1500 : 0;
  const totalProjectedTokens = tokensSoFar + expectedBeaconTokens + expectedShardTokens + remainingBountyTokens;

  const bronze = 3000;
  const silver = 6000;
  const gold = 9000;

  const tierStatus = (threshold) =>
    totalProjectedTokens >= threshold ? "✅" : `⬜ ${threshold - totalProjectedTokens} more`;

  return (
    <div
      style={{
        padding: "2rem",
        maxWidth: "640px",
        margin: "0 auto",
        backgroundColor: "#000",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1>+Beta Token Calculator</h1>
<p>Today is {today.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</p>
<p>Event ends 14 December 2025</p>


      <label>Tokens earned so far</label>
      <input
        type="number"
        value={tokensSoFar || ""}
        onChange={(e) => setTokensSoFar(+e.target.value || 0)}
        style={{
          display: "block",
          marginBottom: "1rem",
          padding: "0.5rem",
          width: "100%",
        }}
      />

      {isBeaconOngoing && (
        <div>
<label>
  Expected number of Battle Beacon interactions
  <span style={{ fontSize: '0.85rem', color: '#aaa' }}> (21 November – 1 December)</span>
</label>

          <input
            type="number"
            value={expectedBeacons || ""}
            onChange={(e) => setExpectedBeacons(+e.target.value || 0)}
            style={{
              display: "block",
              marginBottom: "0.5rem",
              padding: "0.5rem",
              width: "100%",
            }}
          />

          <label>Average expected Battle Beacon category</label>
          <select
            value={beaconTier}
            onChange={(e) => setBeaconTier(e.target.value)}
            style={{
              display: "block",
              marginBottom: "1rem",
              padding: "0.5rem",
              width: "100%",
            }}
          >
            <option value="CAT-I">CAT-I (3 Tokens)</option>
            <option value="CAT-II">CAT-II (7 Tokens)</option>
            <option value="CAT-III">CAT-III (12 Tokens)</option>
            <option value="CAT-IV">CAT-IV (18 Tokens)</option>
            <option value="CAT-V">CAT-V (25 Tokens)</option>
            <option value="CAT-VI">CAT-VI (33 Tokens)</option>
          </select>
        </div>
      )}

      {isShardOngoing && (
        <div>
<label>
  Shard Interactions
  <span style={{ fontSize: '0.85rem', color: '#aaa' }}> (13 December – 14 December)</span>
</label>

          <select
            value={shardCount}
            onChange={(e) => setShardCount(+e.target.value)}
            style={{
              display: "block",
              marginBottom: "1rem",
              padding: "0.5rem",
              width: "100%",
            }}
          >
            <option value={0}>0</option>
            <option value={1}>1</option>
            <option value={2}>2</option>
          </select>
        </div>
      )}

<p>Remaining tokens from bounties: up to {remainingBountyTokens}</p>
<p>Projected maximum tokens: {totalProjectedTokens}</p>


      <h3>Tier Progress</h3>
<div style={{ display: "flex", justifyContent: "space-around", marginBottom: "1rem" }}>
  <div style={{ textAlign: "center" }}>
    <img src="beta_bronze.png" alt="Bronze" style={{ height: "64px", width: "64px" }} />
    <p>Bronze (3000): {tierStatus(bronze)}</p>
  </div>
  <div style={{ textAlign: "center" }}>
    <img src="beta_silver.png" alt="Silver" style={{ height: "64px", width: "64px" }} />
    <p>Silver (6000): {tierStatus(silver)}</p>
  </div>
  <div style={{ textAlign: "center" }}>
    <img src="beta_gold.png" alt="Gold" style={{ height: "64px", width: "64px" }} />
    <p>Gold (9000): {tierStatus(gold)}</p>
  </div>
</div>

    </div>
  );
}

